<template>
  <div class="toNextBtn" v-show="nowPage < 7 && showNextBtn">
    <img :src="toNextBtn" @click="swiperToNext"/>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import toNextBtn from '@/assets/img/toNextBtn.png'

export default {
  mixins: [swiperMixin],
  data () {
    return {
      toNextBtn, // 下一页
    }
  },

  computed: {
    nowPage () {
      return this.$store.state.nowPage
    },
    showNextBtn () {
      return this.$store.state.showNextBtn
    },
  },

  methods: {
    swiperToNext () {
      if ( this.nowPage < 7 ) {
        let nub = this.nowPage + 1
        this.mySlideTo(nub)
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
.toNextBtn
  position absolute
  bottom 50px
  left 50%
  transform translateX(-50%)
  z-index 1
  cursor pointer
  img 
    animation shanBtn 4s linear infinite
    width 70px

@keyframes shanBtn
  0%
    opacity .6
    transform: scale(.6)
  50%
    opacity 1
    transform: scale(1.4)
  100%
    opacity .6
    transform: scale(.6)
</style>